// @flow
import dynamic from 'next/dynamic';

/* eslint-disable import/no-cycle */
export const SkewImage = dynamic(() => import('./SkewImage'));
export const TwoSkewImages = dynamic(() => import('./TwoSkewImages'));
export const Textarea = dynamic(() => import('./Textarea'));
export const Input = dynamic(() => import('./Input'));
export const InputDate = dynamic(() => import('./InputDate'));
export const Select = dynamic(() => import('./Select'));
export const Switch = dynamic(() => import('./Switch'));
export const RadioSwitch = dynamic(() => import('./RadioSwitch'));
export const SwitchGroup = dynamic(() => import('./SwitchGroup'));
export const Checkbox = dynamic(() => import('./Checkbox'));
export const MultiCheckbox = dynamic(() => import('./MultiCheckbox'));
export const Button = dynamic(() => import('./Button'));
export const ButtonSecondary = dynamic(() => import('./ButtonSecondary'));
export const ButtonIcon = dynamic(() => import('./ButtonIcon'));
export { default as NavigationMain } from './NavigationMain';
export const Footer = dynamic(() => import('./Footer'));
export { default as Carousel } from './Carousel';
export const MultipleItemsCarousel = dynamic(() => import('./Carousel/MultipleItems'));
export const Upload = dynamic(() => import('./Upload'));
export { default as Dialog } from './Dialog';
export const FAQs = dynamic(() => import('./FAQs'));
export const LinkBack = dynamic(() => import('./LinkBack'));
export const BulletList = dynamic(() => import('./BulletList'));
export const Separator = dynamic(() => import('./Separator'));
export const TeaserFacility = dynamic(() => import('./TeaserFacility'));
export const ContactPageNew = dynamic(() => import('./ContactPageNew'));
export const ButtonRadio = dynamic(() => import('./ButtonRadio'));
export const ListItemFacility = dynamic(() => import('./ListItemFacility'));
export const Map = dynamic(() => import('./Map'));
export const TeaserTestimonial = dynamic(() => import('./TeaserTestimonial'));
export const TeaserVideo = dynamic(() => import('./TeaserVideo'));
export const TeaserList = dynamic(() => import('./TeaserList'));
export const TeaserGroupTrio = dynamic(() => import('./TeaserGroupTrio'));
export const PrevNext = dynamic(() => import('./PrevNext'));
export const FeedbackButtons = dynamic(() => import('./FeedbackButtons'));
export { default as Cards } from './Cards';
export const Tags = dynamic(() => import('./Tags'));
export const Pagination = dynamic(() => import('./Pagination'));
export const TwoCardTeaser = dynamic(() => import('./TwoCardTeaser'));
export const TeaserImageQuote = dynamic(() => import('./TeaserImageQuote'));
export const MapMarker = dynamic(() => import('./MapMarker'));
export const LoadingSpinner = dynamic(() => import('./LoadingSpinner'));
export const CookieConsent = dynamic(() => import('./CookieConsent'));
export const Masonry = dynamic(() => import('./Masonry'));
export const Video = dynamic(() => import('./Video'));
export const DocumentViewer = dynamic(() => import('./DocumentViewer'));
export const ConfirmationDialog = dynamic(() => import('./ConfirmationDialog'));
export { default as PasswordStrength } from './PasswordStrength';
export { default as StatefulButton } from './StatefulButton';
export const Imgix = dynamic(() => import('./Imgix'));
export const CardHeaderAlert = dynamic(() => import('./CardHeaderAlert'));
export const MetaRobots = dynamic(() => import('./MetaRobots'));
export const CanonicalLink = dynamic(() => import('./CanonicalLink'));
export const LongCard = dynamic(() => import('./LongCard'));
export const HoneypotField = dynamic(() => import('./HoneypotField'));
export const HowItWorks = dynamic(() => import('./HowItWorks'));
export const HomeCard = dynamic(() => import('./HomeCard'));
export const BannerLeft = dynamic(() => import('./BannerLeft'));
export const BannerRight = dynamic(() => import('./BannerRight'));
export const Modal = dynamic(() => import('./Modal'));
export const PackageMiniflow = dynamic(() => import('./PackageMiniflow'));
export const PaypalButton = dynamic(() => import('./PaypalButton'));
/* eslint-enable import/no-cycle */
